// extracted by mini-css-extract-plugin
export var form = "form-elem-module--form--2xQAu";
export var form_flex = "form-elem-module--form_flex--1bNcg";
export var form_field = "form-elem-module--form_field--ZnkCi";
export var form_checkbox = "form-elem-module--form_checkbox--2xtvN";
export var form_textarea = "form-elem-module--form_textarea--r3FUn";
export var form_submit = "form-elem-module--form_submit--uGIBX";
export var hidden = "form-elem-module--hidden--3zzN8";